module.exports = __webpack_public_path__ + "img/073625.2450057c.png";